export default "__VITE_ASSET__062dd21e__"